import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Slider from 'react-slick';
import StockSearch from '../stock-search';
import './search-stock-carousel.m.css';
import RightArrowSmall from '../../atoms/icons/right-arrow-small';
import LeftArrowSmall from '../../atoms/icons/left-arrow-small';

class SearchStockCarousel extends React.Component {
  render() {
    const SLIDER_SETTINGS = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      nextArrow: (
        <div>
          <RightArrowSmall
            color="fourth-color"
            className="content-center-items"
            styleName="arrow-center"
          />
        </div>
      ),
      prevArrow: (
        <div>
          <LeftArrowSmall
            color="fourth-color"
            className="content-center-items"
            styleName="arrow-center"
          />
        </div>
      )
    };
    return (
      <React.Fragment>
        <div className="stocks-slider">
          <Slider {...SLIDER_SETTINGS}>
            {this.props.stocksData.length > 0 &&
              this.props.stocksData.map((stock, i) => {
                return (
                  <div key={get(stock, 'id', i)}>
                    <StockSearch
                      key={stock.STOCKID}
                      stockId={stock.STOCKID}
                      stock={stock}
                      totalCount={this.props.stocksData.length}
                      currentIndex={i}
                    />
                  </div>
                );
              })}
          </Slider>
        </div>
      </React.Fragment>
    );
  }
}

SearchStockCarousel.propTypes = {
  stocksData: PropTypes.array
};

export default SearchStockCarousel;
